module.exports = __webpack_public_path__ + "img/login-square-arrow-button-outline@3x.d72a16b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login-square-arrow-button-outline@3x.png
// module id = g06G
// module chunks = 13